import { db } from "@repo/core/services/firebase";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";

import { isSmileSimulationLanguage } from "../model/i18n";
import type { SmileSimulationLanguage } from "../model/types";

const DEFAULT_SMILE_SIMULATION_LANGUAGE: SmileSimulationLanguage = "en";

type SmileSimulationClinicSettingsDocument = {
  defaultLanguage?: unknown;
};

const getSmileSimulationClinicSettingsRef = (clinicId: string) =>
  doc(db, "smileSimulation", clinicId);

export const getSmileSimulationDefaultLanguage = async (
  clinicId?: string | null,
): Promise<SmileSimulationLanguage> => {
  const normalizedClinicId = clinicId?.trim();

  if (!normalizedClinicId) {
    return DEFAULT_SMILE_SIMULATION_LANGUAGE;
  }

  try {
    const snapshot = await getDoc(
      getSmileSimulationClinicSettingsRef(normalizedClinicId),
    );
    const data = snapshot.data() as
      | SmileSimulationClinicSettingsDocument
      | undefined;

    if (isSmileSimulationLanguage(data?.defaultLanguage)) {
      return data.defaultLanguage;
    }
  } catch (error) {
    console.error("Failed to load smile simulation language defaults:", error);
  }

  return DEFAULT_SMILE_SIMULATION_LANGUAGE;
};

export const updateSmileSimulationDefaultLanguage = async (
  clinicId: string,
  language: SmileSimulationLanguage,
) => {
  await setDoc(
    getSmileSimulationClinicSettingsRef(clinicId),
    {
      defaultLanguage: language,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
};
